var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04736 7.99982V13.3328M14.0472 13.3328V10.6663C14.0472 8.78111 14.0472 7.83783 13.4612 7.25253C12.8758 6.66657 11.9325 6.66657 10.0473 6.66657H9.38061M9.38061 6.66657C9.38061 6.19993 10.7099 5.32798 11.0472 5M9.38061 6.66657C9.38061 7.13321 10.7099 8.00515 11.0472 8.33314",
    stroke: "#09326C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04765 16.0005C6.78401 16.0005 7.38095 15.4036 7.38095 14.6672C7.38095 13.9309 6.78401 13.334 6.04765 13.334C5.31129 13.334 4.71436 13.9309 4.71436 14.6672C4.71436 15.4036 5.31129 16.0005 6.04765 16.0005Z",
    stroke: "#09326C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04765 8.00049C6.78401 8.00049 7.38095 7.40357 7.38095 6.66724C7.38095 5.9309 6.78401 5.33398 6.04765 5.33398C5.31129 5.33398 4.71436 5.9309 4.71436 6.66724C4.71436 7.40357 5.31129 8.00049 6.04765 8.00049Z",
    stroke: "#09326C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0477 16.0005C14.784 16.0005 15.381 15.4036 15.381 14.6672C15.381 13.9309 14.784 13.334 14.0477 13.334C13.3113 13.334 12.7144 13.9309 12.7144 14.6672C12.7144 15.4036 13.3113 16.0005 14.0477 16.0005Z",
    stroke: "#09326C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.d153f1e0b5f65abb378ba4e821458255.svg";
export { ForwardRef as ReactComponent };